import * as React from "react";
import { Box, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";

import GraphicElements from "../../../styles/svg/graphic_elements.svg";
import { useResponsive } from "../../../hooks/useResponsive";
import mobileBg from "../../../styles/svg/login_bg_mobile.svg";
import "./forgotPassword.scss";
import SendLinkConfirmation from "./SendLinkConfirmation";
import ForgotPasswordMessage from "../../../utils/Enums";
import { useAssets } from "../../../reactQuery/domainAssets";
import { getAPIBaseUrl } from "../../../utils/constants";
import TenantSiteName from "../../../components/TenantSiteName";
import { CustomButton } from "../../../components/Button/Button";
import { RFHTextField } from "../../../components/RFH";
import { useForgotPasswordForm } from "../hooks/useForgotPasswordForm";

function ForgotPassword() {
  const isMobile = useResponsive("down", "md");
  const { logo } = useAssets();
  const apiUrl = getAPIBaseUrl();
  const {
    methods,
    showSuccess,
    isLoading,
    submitData,
    handleBackToLogin,
    handleFormError,
  } = useForgotPasswordForm();
  const { handleSubmit } = methods;

  return (
    <Box
      component="main"
      className="forgotpassword-box"
      sx={{
        backgroundImage: `url(${isMobile ? mobileBg : GraphicElements})`,
      }}
      disableGutters={true}
    >
      <Box className="forgotpassword-innerBox">
        {logo ? (
          <img
            src={`${apiUrl}/${logo}`}
            alt="not found"
            width={isMobile ? 251 : ""}
            className="login_logo"
          />
        ) : (
          <TenantSiteName />
        )}
        {showSuccess ? (
          <SendLinkConfirmation />
        ) : (
          <FormProvider {...methods}>
            <Box
              component="form"
              onSubmit={handleSubmit(submitData, handleFormError)}
              noValidate
              className="submitForm-box"
            >
              <Typography
                className="text-center black-primary-color mb-4 weight-700"
                component={"h1"}
                variant="h5"
              >
                {ForgotPasswordMessage.FORGOT_PASSWORD}
              </Typography>
              <Typography
                className="text-center forgot-password-para mb-4"
                variant="body1"
              >
                {ForgotPasswordMessage.FORGOT_PASSWORD_MESSAGE}
              </Typography>
              <RFHTextField
                margin="normal"
                required
                fullWidth
                id="email"
                label={"Email Address"}
                name="email"
                type="email"
                autoComplete="email"
                className="primary-input-field"
                autoFocus
                defaultPadding={false}
              />
              {/* <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label={"Email Address"}
                name="email"
                type="email"
                error={errors?.email ? true : false}
                helperText={errors?.email && errors.email.message}
                autoComplete="email"
                autoFocus
                {...register("email", {
                  required: "Email is required",
                  validate: {
                    isValidEmail: (value) =>
                      isEmail(value) || "Please enter a valid email address",
                  },
                })}
                className="primary-input-field"
              /> */}

              <CustomButton
                type="submit"
                fullWidth
                variant="contained"
                className="btn-blue capitalize submit-button"
                disabled={isLoading}
              >
                Send instructions
              </CustomButton>

              <div className="d-flex justify-content-center mt-4">
                <p className="card-anchor " onClick={handleBackToLogin}>
                  Back to login
                </p>
              </div>
            </Box>
          </FormProvider>
        )}
      </Box>
    </Box>
  );
}

export default ForgotPassword;
